import Store from '@/store'

export class InfoStoreUtils {

    static fethUsersCountPerApp() {
        return Store.dispatch("info-store/fethUsersCountPerApp");
    }

    static fethUsersCountPerPackage() {
        return Store.dispatch("info-store/fethUsersCountPerPackage");
    }

    static removeUsersCountPerApp(data) {
        return Store.dispatch("info-store/removeUsersCountPerApp", data);
    }

    static getUsersCountPerApp() {
        return Store.getters["info-store/getUsersCountPerApp"];
    }

    static getUsersCountPerPackage() {
        return Store.getters["info-store/getUsersCountPerPackage"];
    }
}